<template>
    <div class="index_main">
        <div class="index_banner">
            <el-carousel height="520px">
                <el-carousel-item>
                    <img src="../assets/images/banner.png" />
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="bgc">
            <div class="con index_modTop">
                <div class="index_modTopItem1">
                    <div class="flex_bet_h">
                        <div class="index_flexDR">
                            <img class="index_flexDR_img" src="../assets/images/img2/jiqiren.png" alt="">
                            <div>
                                <p class="index_fontS24">合成配音</p>
                                <p class="index_fontS16 index_fontC">专业配音工具，文字立刻变声音</p>
                            </div>
                        </div>
                        <router-link to="/make">
                            <div class="index_modTopItemBtn index_modTopItemBtnC1">制作合成配音</div>
                        </router-link>
                    </div>
                    <div class="index_flexDR index_flexWw">
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/AIzhineng.png" alt="">
                            <div>
                                <p class="index_fontS16">超级主播</p>
                                <p class="index_fontS12 index_fontC">人声近似度高达96%</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/AIzhineng.png" alt="">
                            <div>
                                <p class="index_fontS16">普通主播</p>
                                <p class="index_fontS12 index_fontC">人声近似度高达82%</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/huojian.png" alt="">
                            <div>
                                <p class="index_fontS16">简单高效</p>
                                <p class="index_fontS12 index_fontC">PC/APP随时能配音</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/maikefeng.png" alt="">
                            <div>
                                <p class="index_fontS16">海量主播</p>
                                <p class="index_fontS12 index_fontC">风格多样自由选择</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/heartPulse.png" alt="">
                            <div>
                                <p class="index_fontS16">情绪丰富</p>
                                <p class="index_fontS12 index_fontC">不同场景不同情绪</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/daochu.png" alt="">
                            <div>
                                <p class="index_fontS16">一键导出</p>
                                <p class="index_fontS12 index_fontC">导出多种格式文件</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="index_modTopItem2">
                    <div class="flex_bet_h">
                        <div class="index_flexDR">
                            <img class="index_flexDR_img" src="../assets/images/img2/maike.png" alt="">
                            <div>
                                <p class="index_fontS24">真人配音</p>
                                <p class="index_fontS16 index_fontC">资深配音专家，给你想要的声音</p>
                            </div>
                        </div>
                        <router-link to="/real_dubbing">
                            <div class="index_modTopItemBtn index_modTopItemBtnC2" @click="setReal()">制作真人配音</div>
                        </router-link>
                    </div>
                    <div class="index_flexDR index_flexWw">
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/voice.png" alt="">
                            <div>
                                <p class="index_fontS16">天籁音质</p>
                                <p class="index_fontS12 index_fontC">资深老师量身定制</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/tuandui.png" alt="">
                            <div>
                                <p class="index_fontS16">专业团队</p>
                                <p class="index_fontS12 index_fontC">专业团队资深配音师</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/more.png" alt="">
                            <div>
                                <p class="index_fontS16">行业覆盖</p>
                                <p class="index_fontS12 index_fontC">契合你的使用场景</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/vip.png" alt="">
                            <div>
                                <p class="index_fontS16">海量大咖</p>
                                <p class="index_fontS12 index_fontC">资深老师任你选择</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/server.png" alt="">
                            <div>
                                <p class="index_fontS16">优质服务</p>
                                <p class="index_fontS12 index_fontC">客服一对一贴身服务</p>
                            </div>
                        </div>
                        <div class="index_topItem">
                            <img class="index_img" src="../assets/images/img2/wljg.png" alt="">
                            <div>
                                <p class="index_fontS16">价廉物美</p>
                                <p class="index_fontS12 index_fontC">私人订制价格亲民</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="index_mod1 animated">
            <div class="">
                <div class="index_mod1top animated fadeInUp">
                    <div class="index_mod1text">
                        <p class="index_mo1tit1">多种场景覆盖</p>
                        <p class="index_mo1tit2">完全契合你的使用场景</p>
                    </div>
                    <div class="index_mod1bg"></div>
                </div>
                <div class="index_mod1list con">
                    <div class="index_mod1li animated fadeInUp">
                        <img src="../assets/images/laba.png" />
                        <div>
                            <p class="index_mod1li_tit">广告配音</p>
                            <p class="index_mod1li_text">
                                海量广告配音模板，可快速套用，通过丰富的工具快捷创建自己的叫卖声音
                            </p>
                        </div>
                    </div>
                    <div class="index_mod1li animated fadeInUp">
                        <img src="../assets/images/index_topsp.png" />
                        <div>
                            <p class="index_mod1li_tit">视频配音</p>
                            <p class="index_mod1li_text">
                                通过插入停顿、切换主播、插入背景音能轻松创作多彩多样的音频作品
                            </p>
                        </div>
                    </div>
                    <div class="index_mod1li animated fadeInUp">
                        <img src="../assets/images/index_topld.png" />
                        <div>
                            <p class="index_mod1li_tit">真人配音</p>
                            <p class="index_mod1li_text">
                                专业配音团队，多样风格任意选，定制您的专属作品
                            </p>
                        </div>
                    </div>
                    <div class="index_mod1li animated fadeInUp">
                        <img src="../assets/images/index_topjg.png" />
                        <div>
                            <p class="index_mod1li_tit">实用工具</p>
                            <p class="index_mod1li_text">
                                集成音频剪辑、短视频去水印、作品拼接、格式转换等实用工具
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="index_mod2">
            <img src="../assets/images/indexmodbg.png" class="index_mod2bg" />
            <div class="index_mod2con">
                <div class="index_mod1top animated" :class="ani_list.index_mod2_ani ? 'fadeInUp' : ''" v-show="ani_list.index_mod2_ani">
                    <div class="index_mod1text">
                        <p class="index_mo1tit1">海量主播声音</p>
                        <p class="index_mo1tit2">多类型样音模板随心用</p>
                    </div>
                    <div class="index_mod1bg"></div>
                </div>
                <el-carousel height="640px" class="index_mod2_banner" indicator-position="outside" :autoplay="false">
                    <el-carousel-item v-for="(item, index) in demolist" :key="index">
                        <div class="flex_ali index_mod2_list" v-show="ani_list.index_mod2_ani">
                            <div class="index_mod2_li animated" v-for="(item2, index2) in item" :key="index2" :class="[
                  index2 == 0 && ani_list.index_mod2_ani ? 'fadeInUp' : '',
                  index2 == 1 && ani_list.index_mod2_ani ? 'fadeInUp' : '',
                  index2 == 2 && ani_list.index_mod2_ani ? 'fadeInUp' : '',
                ]">
                                <div class="index_mod2_litop">
                                    <span class="index_mod2_litopl">{{ item2.catname }}</span>
                                    <router-link to="/demo"><span class="index_mod2_litopr">查看全部></span></router-link>
                                </div>
                                <ul>
                                    <li v-for="(item3, index3) in item2.zhuboList" :key="index3">
                                        <div class="flex_ali">
                                            <img :src="item3.zbcover" class="index_mod2_liavater" />
                                            <div>
                                                <p>{{ item3.speakername }}</p>
                                                <p class="index_mod2_text1">
                                                    {{ item3.zbdesp }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="flex_ali">
                                            <div class="index_mod2_btn" :class="
                          demo_audio.audiourl == item3.zbmusicurl
                            ? 'index_mod2_btnact'
                            : ''
                        " @click="real_audio.stop(),demo_audio.play(item3.zbmusicurl)">
                                                <img src="../assets/images/pause.png" v-if="demo_audio.audiourl == item3.zbmusicurl" />
                                                <img src="../assets/images/play.png" v-else />
                                                <span>{{
                          demo_audio.audiourl == item3.zbmusicurl
                            ? "暂停"
                            : "试听"
                        }}</span>
                                            </div>
                                            <div class="index_mod2_btn" @click="setDubbingDemo(item3)">
                                                <img src="../assets/images/enit.png" />
                                                <span>使用</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <router-link to="/demo">
                <div class="index_mod2btn">查看全部样音</div>
            </router-link>
        </div>
        <div class="index_mod2 index_mod3">
            <div class="index_mod2con">
                <div class="index_mod1top animated" :class="ani_list.index_mod3_ani ? 'fadeInUp' : ''" v-show="ani_list.index_mod3_ani">
                    <div class="index_mod1text">
                        <p class="index_mo1tit1">专业配音团队</p>
                        <p class="index_mo1tit2">定制您的专属配音作品</p>
                    </div>
                    <div class="index_mod1bg"></div>
                </div>
                <el-carousel height="640px" class="index_mod2_banner" indicator-position="outside" :autoplay="false" v-show="ani_list.index_mod3_ani">
                    <el-carousel-item v-for="(item, index) in reallist" :key="index">
                        <div class="flex_ali index_mod3_list">
                            <div class="index_mod3_li animated" v-for="(item2, index2) in item" :key="index2" :class="[
                  index2 > 1 && ani_list.index_mod3_ani ? 'fadeInUp' : '',
                  index2 <= 1 && ani_list.index_mod3_ani ? 'fadeInUp' : '',
                ]">
                                <div class="index_mod3top">
                                    <img :src="item2.cover" />
                                    <div>
                                        <p class="flex_ali">
                                            <span class="index_mod3name">{{
                        item2.speakername
                      }}</span>
                                            <span class="index_mod3state">在线</span>
                                        </p>
                                        <p class="index_mod3desp">{{ item2.fittype }}</p>
                                    </div>
                                </div>
                                <div class="anchot_demolist">
                                    <div class="index_mod3li" v-for="(item3, index3) in JSON.parse(item2.soundinfo)" :key="index3">
                                        <div>
                                            <p class="realanchor_name overflow_hide">
                                                {{ item3.soundname }}
                                            </p>
                                            <p class="index_mod3li_text">
                                                <img src="../assets/images/index_bz.png" />
                                                <span>{{ item3.label }}</span>
                                            </p>
                                        </div>
                                        <div class="flex_ali">
                                            <div class="index_mod2_btn" :class="
                          real_audio.audiourl == item3.soundurl
                            ? 'index_mod2_btnact'
                            : ''
                        " @click="demo_audio.stop(),real_audio.play(item3.soundurl)">
                                                <img src="../assets/images/pause.png" v-if="real_audio.audiourl == item3.soundurl" />
                                                <img src="../assets/images/play.png" v-else />
                                                <span>{{
                          real_audio.audiourl == item3.soundurl
                            ? "暂停"
                            : "试听"
                        }}</span>
                                            </div>
                                            <router-link to="/real_dubbing">
                                                <div class="index_mod2_btn" @click="setReal(item2), setChose(item3)">
                                                    <img src="../assets/images/enit.png" />
                                                    <span>使用</span>
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <router-link to="/real">
                <div class="index_mod2btn index_mod4btn">查看全部主播</div>
            </router-link>
        </div>

        <div class="index_mod4">
            <img src="../assets/images/index_mod4bg.png" class="index_mod4bg" />
            <div class="index_mod4con">
                <div class="index_mod1top animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''" v-show="ani_list.index_mod4_ani">
                    <div class="index_mod1text">
                        <p class="index_mo1tit1">集成实用工具</p>
                        <p class="index_mo1tit2">集成多种工具轻松上手</p>
                    </div>
                    <div class="index_mod1bg"></div>
                </div>
                <div class="index_mod4list">
                    <!-- <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_ypxg.png" />
                        <div>
                            <p class="index_mod4litit">音频修改</p>
                            <p class="index_mod4litext">修改采样率等属性</p>
                        </div>
                    </div> -->
                    <!-- <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_sw.png" />
                        <div>
                            <p class="index_mod4litit">格式转换</p>
                            <p class="index_mod4litext">改变文件格式类型</p>
                        </div>
                    </div> -->
                    <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_yl.png" />
                        <div>
                            <p class="index_mod4litit">音量放大</p>
                            <p class="index_mod4litext">增强音频文件音量</p>
                        </div>
                    </div>
                    <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_pj.png" />
                        <div>
                            <p class="index_mod4litit">作品拼接</p>
                            <p class="index_mod4litext">多个配音作品拼接</p>
                        </div>
                    </div>
                    <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_by.png" />
                        <div>
                            <p class="index_mod4litit">音频变音</p>
                            <p class="index_mod4litext">改变音频主播音色</p>
                        </div>
                    </div>
                    <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_jbg.png" />
                        <div>
                            <p class="index_mod4litit">加背景音</p>
                            <p class="index_mod4litext">作品添加背景音乐</p>
                        </div>
                    </div>
                    <!-- <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_cj.png" />
                        <div>
                            <p class="index_mod4litit">音频剪裁</p>
                            <p class="index_mod4litext">仅保留需要的部分</p>
                        </div>
                    </div> -->
                    <div class="index_mod4li animated" :class="ani_list.index_mod4_ani ? 'fadeInUp' : ''">
                        <img src="../assets/images/index_qsy.png" />
                        <div>
                            <p class="index_mod4litit">去水印</p>
                            <p class="index_mod4litext">清除短视频水印</p>
                        </div>
                    </div>
                </div>
                <router-link to="/tools">
                    <div class="index_mod2btn index_mod4btn">
                        立即体验工具
                    </div>
                </router-link>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import PlayListAudio from "../utils/PlayListAudio.js";
import Footer from "../components/footer.vue";
import { mapState } from "vuex";
export default {
    components: {
        Footer,
    },
    data() {
        return {
            // 模板样音播放器对象
            demo_audio: new PlayListAudio(),
            real_audio: new PlayListAudio(),
            // 动画控制开关
            ani_list: {
                index_mod2_ani: false,
                index_mod3_ani: false,
                index_mod4_ani: false,
                index_mod5_ani: false,
            },
        };
    },
    computed: {
        ...mapState(["reallist", "demolist"]),
    },
    mounted() {
        if (this.$store.state.demolist.length == 0) {
            this.getDubbingDemo();
        }
        if (this.$store.state.reallist.length == 0) {
            this.getRealDemo();
        }
        window.addEventListener("scroll", this.handleScroll, true);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        this.demo_audio.stop();
        this.real_audio.stop();
    },
    methods: {
        downIos() {
            this.$message("暂未开放");
        },
        //保存真人主播到vuex
        setReal(realAnchor) {
            this.$store.commit("setRealAnchor", realAnchor);
        },
        //保存选中案例到vuex
        setChose(choseMusic) {
            this.$store.commit("setChoseMusic", choseMusic);
        },
        // 使用模板样音
        setDubbingDemo(item) {
            let self = this;
            let url =
                self.$store.state.app_api +
                self.$store.state.app_url.qryzhubodetail;
            this.$request.postHttp({ zbid: item.zbid }, url, (decData) => {
                this.$store.commit("setAnchor", decData.model);
                this.$router.push({
                    path: "/make",
                    query: {
                        voicetext: item.voicetext,
                    },
                });
            });
        },
        //滚动事件
        handleScroll() {
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            //   console.log(scrollTop);
            if (scrollTop >= 200 && this.ani_list.index_mod2_ani == false) {
                this.ani_list.index_mod2_ani = true;
            } else if (
                scrollTop >= 1100 &&
                this.ani_list.index_mod3_ani == false
            ) {
                this.ani_list.index_mod3_ani = true;
            } else if (
                scrollTop >= 1450 &&
                this.ani_list.index_mod4_ani == false
            ) {
                this.ani_list.index_mod4_ani = true;
            } else if (
                scrollTop >= 2700 &&
                this.ani_list.index_mod5_ani == false
            ) {
                this.ani_list.index_mod5_ani = true;
            }
        },
        // 获取真人样音
        getRealDemo() {
            let self = this;
            let url =
                self.$store.state.app_api +
                self.$store.state.app_url.qrylivespeakers;
            this.$request.postHttp({}, url, (decData) => {
                console.log(decData)
                this.$store.commit(
                    "setRealList",
                    self.groupArray(decData.model[1].livespeakerList, 4)
                );
            });
        },
        // 获取主播列表
        getDubbingDemo() {
            let self = this;
            let url =
                self.$store.state.app_api + self.$store.state.app_url.qryttszhubov5;
            this.$request.postHttp({}, url, (decData) => {
                console.log(1,decData.model.ttsZhuboAllList)
                let ttsZhuboAllList = decData.model.ttsZhuboAllList
                const [first, ...rest] = ttsZhuboAllList;
                ttsZhuboAllList = [...rest,first]
                this.$store.commit(
                    "setDemoList",
                    self.groupArray(ttsZhuboAllList, 3)
                );
            });
        },
        // 获取模板样音
        // getDubbingDemo() {
        //     let self = this;
        //     let url =
        //         self.$store.state.app_api +
        //         self.$store.state.app_url.qrysamplemusicv6;
        //     this.$request.postHttp({}, url, (decData) => {
        //         this.$store.commit(
        //             "setDemoList",
        //             self.groupArray(decData.model, 3)
        //         );
        //     });
        // },
        // 将数组分割成几段(用于首页轮播图数据处理)
        groupArray(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, (index += subGroupLength)));
            }
            return newArray;
        },
        // 获取真人老师列表
        getRealAnhor() {},
    },
    watch: {
        $route(to, from) {
            this.demo_audio.stop();
            this.real_audio.stop();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/view/index.vue